require("./menta_laisha_site_header-mobile.less")
import { LinkTargetProperties } from "global/components/linkSettings/interfaces";
import { LaishaSubChannelMenuMobile } from "./laishaMobileSubChannelHeader";
import { HyperLinkBuilder } from "widgets/commonComponents/inline/hyperLink"
import { SiteSimpleImage } from "widgets/commonComponents/inline/siteSimpleImage"
import { getImagesSrc } from "../../../../commonComponents/inline/siteSimpleImage"

export interface laishaHeaderMenuItem {
    title: string
    link: string
    linkTarget: LinkTargetProperties
}

interface laishaHeaderMenuProps {
    items: laishaHeaderMenuItem[]
    id?: string
    siteLogoUrl: string
    parentSiteLogoUrl: string
    siteLogoLink: string
    parentSiteLogoLink: string
    parentSiteLogoTarget?: any
    siteLogoTarget?: any
    siteLogoTitle?: any
    parentSiteLogoTitle?: any
    instagramLink: string
    facebookLink: string
    contactusLink: string
    imagesDomain: string
}

interface MobileLaishaHeaderState {
    isOpened: boolean
}

export class MobileLaishaHeader extends React.Component<laishaHeaderMenuProps, MobileLaishaHeaderState>{
    public static siteScriptName = "MobileLaishaHeader";
    private scrollPosition: number = 0;
    
    constructor(props) {
        super(props)
        this.state = {
            isOpened: null
        }
    }

    componentWillUnmount() {
        // Ensure body scrolling is restored if component unmounts while menu is open
        if (this.state.isOpened) {
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            // Restore scroll position
            window.scrollTo(0, this.scrollPosition);
        }
    }

    private openMenu = () => {
        this.setState({ isOpened: true }, () => {
            this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            document.body.style.overflow = "hidden";
            document.body.style.position = "fixed";
            document.body.style.top = `-${this.scrollPosition}px`;
            document.body.style.width = "100%";
        })
       
    }
    private closeMenu = () => {
        this.setState({ isOpened: false }, () => {
           
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            window.scrollTo(0, this.scrollPosition);
        })
    }

    render() {

        const { items, instagramLink, facebookLink, contactusLink, siteLogoUrl, parentSiteLogoUrl, siteLogoLink, parentSiteLogoTitle, siteLogoTitle,
            parentSiteLogoLink, siteLogoTarget, parentSiteLogoTarget, imagesDomain } = this.props
        const { isOpened } = this.state
        const isApp = typeof window !== "undefined" && window.location.href.indexOf("IsApp") != -1;
        return (
            <div className={`MobileLaishaHeader LaishaHeaderComponenta ${isApp ? "isApp" : ""}`}  >
                <div className="topHeader">
                    {!isOpened && <button className="HamBtn" onClick={this.openMenu} />}
                    {isOpened && <button className="hamMenuClsBtn" onClick={this.closeMenu} />
                    }

                    <HyperLinkBuilder className="mainSiteLogo" href={siteLogoLink} linkTarget={siteLogoTarget} rel="nofollow">
                        <SiteSimpleImage src={getImagesSrc(imagesDomain, siteLogoUrl)} title={siteLogoTitle} />
                    </HyperLinkBuilder>

                    <a href="javascript:history.back()">
                        <div className="arrowBack" />
                    </a>


                </div>
                <LaishaSubChannelMenuMobile
                    items={items}
                    parentSiteLogoUrl={parentSiteLogoUrl}
                    parentSiteLogoLink={parentSiteLogoLink}
                    parentSiteLogoTarget={parentSiteLogoTarget}
                    parentSiteLogoTitle={parentSiteLogoTitle}
                    isOpened={isOpened}
                    onClose={this.closeMenu}
                    instagramLink={instagramLink}
                    facebookLink={facebookLink}
                    contactusLink={contactusLink}
                />

            </div>
        )
    }
}



